import PerfectScrollbar from 'perfect-scrollbar';

$(function(){
	var iosScrollEls = $('.ios-scroll');

	var scrollBars = [];
	for(var i = 0; i < iosScrollEls.length; i++) {
		var iosScrollEl = iosScrollEls[i];

		scrollBars.push(new PerfectScrollbar(iosScrollEl, {
			suppressScrollX: true
		}));
	}
});